import React, {useEffect, useState} from 'react';
import {Badge, ListGroup, ListGroupItem, Modal, ModalBody} from 'reactstrap';
import {connect} from 'react-redux';
import {group} from '../../redux';
import LoaderWidget from '../../../ui/components/Loader';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {actions as userActions} from "../../redux/user.reducers";
import {actions as groupActions} from "../../redux/group.reducers";
import FormBuilder from "../../../ui/components/Form/FormBuilder";
import {cloneObject} from "../../../../shared/fileUtils";

const AddGroupUserComponent = props => {
    const initialState = {
        selected: [],
        id: null, // id to update entity

        optionListDefault: [], //
        originalList: [], // users exists in database, use to validate removing users list
        currentList: [], // users exists in database, to be display on UI
        optionList: [], // users to choose to add to current list

        addList: [], // users to be added
        removeList: [], // users to be removed
        loaded: false,

        inputs: [
            {
                type: 'typeahead',
                name: 'adding_user',
                label: 'Available users',
                placeholder: 'Choose user to add to group',
                required: true,
                options: [],
                optionKey: 'email',
                error: {
                    message: ''
                }
            },
        ],

        submitButton: 'Save',
    };

    const [componentState, setComponentState] = useState(initialState);

    let currentList = componentState.currentList;
    let optionList = componentState.optionList;
    let addList = componentState.addList;
    let removeList = componentState.removeList;
    let inputs = componentState.inputs;
    let originalList = componentState.originalList;
    let optionListDefault = componentState.optionListDefault;

    // global state
    const setGlobalState = () => {
        currentList = componentState.currentList;
        optionList = componentState.optionList;
        addList = componentState.addList;
        removeList = componentState.removeList;
        inputs = componentState.inputs;
        originalList = componentState.originalList;
        // optionListDefault = componentState.optionListDefault;
    };

    const setFormOptions = (optionList) => {
        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].name === 'adding_user') {
                inputs[i].options = optionList;
            }
        }
        inputs = cloneObject(inputs);
        setComponentState({...componentState, inputs});
        setGlobalState();

    };

    useEffect(() => {
        if (componentState.currentList.length === 0) {
            props.listUserOption();
        }
    }, []);

    useEffect(_ => {
        setComponentState({...componentState, loaded: false, currentList: []});
    }, [props.data])

    const existInList = (item, list) => {
        for (let i = 0; i < list.length; i++) {
            if (list[i].resource_id === item.resource_id) {
                return true;
            }
        }
        return false;
    };

    // load initial list
    if (componentState.currentList.length === 0 && props.data && !componentState.loaded && props.data.users) {

        const currentList = cloneObject(props.data.users);
        const originalList = cloneObject(currentList);

        optionListDefault = cloneObject(props.userOptions);
        let optionList = [];

        // remove duplicates in optionList from currentList
        for (let i = 0; i < optionListDefault.length; i++) {
            const option = optionListDefault[i];
            if (existInList(option, currentList)) {
                continue;
            }
            optionList.push(option);
        }

        // put option list to form
        setFormOptions(optionList);

        setComponentState({
            ...componentState,
            id: props.data.resource_id,
            optionListDefault,
            optionList,
            originalList,
            currentList,
            inputs,
            loaded: true
        });

        setGlobalState()
    }

    const toggle = () => {
        props.close();
    };

    const handleFormChange = (value) => {

        if (!value || !Object.keys(value)) {
            return;
        }

        const field = Object.keys(value)[0];
        value = value[field];


        if (!value[0]) {
            return;
        }
        const optionId = value[0].resource_id;

        // adding users
        if (addList.indexOf(optionId) === -1) {
            const allowedAdd = !existInList(value[0], originalList);
            if (allowedAdd) {
                addList.push(optionId);
            }

            // check if user to be remove from removing list
            const removingUser = originalList.find(item => item.resource_id === optionId);
            if (removingUser) {
                removeList.splice(removeList.indexOf(removingUser.id), 1)
            }

        }

        currentList.push(value[0]);

        // filter option list
        optionList = [];
        for (let i = 0; i < optionListDefault.length; i++) {
            const option = optionListDefault[i];
            if (existInList(option, currentList)) {
                continue;
            }
            optionList.push(option);
        }

        setComponentState({...componentState, currentList, optionList, addList, removeList});

        setFormOptions(optionList);

        setGlobalState();
    };

    const handleSubmitForm = () => {
        const params = {
            group_id: componentState.id,
            removing_ids: componentState.removeList,
            adding_ids: componentState.addList,
        };

        props.updateUserInGroup(params);

        toggle();
    };


    const handleRemoveItemList = (option, index) => {
        optionList.push(option);

        currentList.splice(index, 1);

        const addList = [];

        // check if users can be add to remove list
        let removingUser = originalList.find(item => item.resource_id === option.resource_id);

        if (removingUser) {
            removeList.push(removingUser.resource_id);
        }

        // set new adding list, item in this list must not exist in both original list and removing list
        for (let i = 0; i < currentList.length; i++) {
            const tmp = currentList[i];
            if (removeList.indexOf(tmp.resource_id) !== -1 || existInList(tmp, originalList)) {
                continue;
            }
            addList.push(tmp.resource_id);
        }

        // filter option list
        optionList = [];
        for (let i = 0; i < optionListDefault.length; i++) {
            const option = optionListDefault[i];
            if (existInList(option, currentList)) {
                continue;
            }
            optionList.push(option);
        }
        // re-render form
        setFormOptions(optionList);

        setComponentState({...componentState, currentList, optionList, addList, removeList});

        setGlobalState();
    };


    const users = currentList.map((option, index) => {
        return (
            <ListGroupItem className="justify-content-between align-items-center"
                           key={option.resource_id}
            >
                <div style={{
                    height: '30px', lineHeight: '30px', float: 'left'
                }}>
                    {option.email}
                </div>
                <Badge className={'d-flex align-items-center justify-content-center'}
                       style={{
                           cursor: 'pointer',
                           height: '30px', lineHeight: '30px',
                           width: '40px', float: 'right'
                       }}
                       onClick={e => handleRemoveItemList(option, index)}
                >
                    <i className='dripicons-cross'/>
                </Badge>
            </ListGroupItem>
        );
    });

    return (
        <Modal
            isOpen={props.show}
            toggle={toggle}
            className='modal-right modal-content justify-content-start filled-modal'>
            <div className='modal-header'>
                <h4>
                    Manage Group User
                </h4>
            </div>
            <ModalBody className='flex-fill d-flex pb-0'>
                {props.loading && <LoaderWidget/>}

                <FormBuilder onSubmit={handleSubmitForm}
                             close={toggle}
                             form={componentState}
                             onChange={handleFormChange}
                >
                    <ListGroup className='w-100'>
                        {users}
                    </ListGroup>
                </FormBuilder>
            </ModalBody>
        </Modal>
    );

};

const mapStateToProps = state => {
    const {loading, userOptions} = state.UserCore;
    return {
        loading, userOptions
    };
};

export default connect(
    mapStateToProps,
    {
        updateUserInGroup: groupActions['updateUserInGroup'],
        listUserOption: userActions['listUserOption'],
        create: group.actions.create,
        update: group.actions.update,
    }
)(AddGroupUserComponent);
